<template>
    <div class="order-group" v-if="screenWidth">
        <table>
            <tr class="order-header">
                <th></th>
                <th>{{$t('user_center_order_product')}}</th>
                <th>{{$t('user_center_order_price')}}</th>
                <th>{{$t('user_center_order_Quantity')}}</th>
                <th>{{$t('user_center_order_Subtotal')}}</th>
                <th v-if="isOpera">{{$t('user_order_operation')}}</th>
            </tr>
        </table>
        <div class="order-group-lists">
            <table class="order-group-list" v-for="(list,index) in lists" :key="index">
                <tr class="order-content">
                    <th class="goods-header">
                        <img :src="list.goods_img" alt="" width="150">
                    </th>
                    <th class="goods-desc">
                        <h3>{{list.goods_name}}</h3>
                        <p style="margin-top:10px;font-size: 18px;color: #0084ff;">{{list.content}}</p>
                        <p style="margin-top:10px;font-size: 18px;color: #0084ff;">{{list.goods_remarks}}</p>
                    </th>
                    <th class="goods-price">
                        <h3>${{list.goods_price}}</h3>
                    </th>
                    <th class="goods-num">
                        <h3>{{list.goods_num}}</h3>
                    </th>
                    <th class="goods-price text-primary">
                        <h3>${{parseFloat(list.goods_price) * parseInt(list.goods_num)}}</h3>
                    </th>
                    <th class="goods-operation" v-if="isOpera">
                        <slot>
                        <router-link :to="{name: 'ProductDetails',params:{id:goods_id}}">{{$t('user_center_order_order_details')}}</router-link>
                        </slot>
                    </th>
                </tr>
            </table>
        </div>
    </div>
    <div class="order-group" v-else>
        <div class="order-group-lists" v-for="(list,index) in lists" :key="index">
                    <div class="goods-header">
                        <img :src="list.goods_img" alt="">
                    </div>
                    <div class="goods-desc">
                        <h3>
                            {{list.goods_name}}
                        </h3>
                        <p style="margin-top:10px;font-size: 18px;color: #0084ff;">{{list.content}}</p>
                        <p>${{list.goods_price}} x {{list.goods_num}}</p>
                        <div class="goods-num">
                            <span class="goods-price text-primary" style="font-size: 15px;">{{$t('user_center_order_Subtotal')}}</span>
                            <span class="goods-price text-primary" style="font-size: 15px;">${{list.goods_price * list.goods_num}}</span>
                        </div>
                    </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            lists: Array,
            isOpera: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            screenWidth: function () {
                console.log(document.body.clientWidth > 500)
                return document.body.clientWidth > 500
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../scss/common";

    .order-group {
        .order-header {
            flex-wrap: nowrap;
            width: 90%;
            max-width: 1240px;
            margin: 10px auto;
            th{
               width: 300px;
               font-size: 14px;
            }

        }
        .order-group-lists {
            .order-group-list{
                margin-top:10px;
                margin-bottom:10px;
                .order-content{
                            background: #F9FCFF;
                            flex-wrap: nowrap;
                            width: 100%;
                            max-width: 1240px;
                            th{
                                width: 300px;
                            }
                            .goods-header {

                                padding: 20px;
                                img{
                                    width: 100%;
                                    max-width: 150px;
                                  }

                            }
                            .goods-desc {
                                h3 {
                                    font-size: 18px;
                                    color: #5E6D82;
                                    letter-spacing: 0;
                                    margin-top: 10px;
                                    line-height: 24px;
                                    font-weight: 500;
                                }
                                p {
                                    font-size: 16px;
                                    color: #5E6D82;
                                    letter-spacing: 0;
                                    line-height: 20px;
                                }
                            }

                            .goods-price, .goods-num {
                                    font-size: 24px;
                                    color: #5E6D82;
                                    letter-spacing: 0;
                                    line-height: 26px;
                                    h3{
                                        font-weight: 500;
                                    }
                            }
                            .text-primary {
                                color: #0084FF;
                            }
                            .goods-operation {
                                font-size: 16px;
                                color: #5E6D82;
                                letter-spacing: 0;
                                line-height: 24px;
                            }
                        }
                    }
        }
        .goods-checkbox {
            display: flex;
            margin-left: 8px;
            align-items: center;
        }
    }


    @media screen and (max-width:414px) {
        .order-group {
            text-align: left;
            width:100%;
            .order-group-lists{
                width: 100%;
                display: flex;
                margin: 15px 0;
                .goods-header{
                    width: 35%;
                    img{
                        width: 100%;
                        max-width: 200px;
                        min-width: 100px;
                    }
                 }
                .goods-desc{
                    width: 65%;
                    padding-left: 20px;
                    text-align: left;
                    h3{
                        font-size: 16px;
                        a{
                            float: right;
                            padding-right: 10px;
                        }
                    }
                p{
                    margin-right: 10px;
                    margin-bottom: 10px;
                    font-size: 15px;
                    border-bottom: 1px solid #e6e6e6;
                }
                .goods-num .goods-num-editable {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;

                .goods-price{
                    font-size: 16px;
                    padding-left: 25px;
                }
                button {
                    border: none;
                    padding: 3px 15px;
                    color: #fff;
                    i {
                        vertical-align: middle;
                    }
                }
                .minus {
                    border-bottom-left-radius: 5px;
                    border-top-left-radius: 5px;
                    background: #D3DCE6;
                    &:active {
                         background: darken(#D3DCE6, 10%)
                     }
                }
                .plus {
                    border-bottom-right-radius: 5px;
                    border-top-right-radius: 5px;
                    background-color: #0084FF;
                    &:active {
                         background: darken(#0084FF, 10%)
                     }
                }
                }
                }

            }

        }
    }
</style>



// WEBPACK FOOTER //
// Listing.vue?7d2fe29b